import { adjacentInsetEdgesToPoints } from "./adjacentEdgesToPoints"
import type { InsetEdge } from "./getInsetEdges"
import type { Edge2dComputed } from "../../mesh"
import { findAngle, findOffsetAngle } from "../findOffsetAngle"

export type InsetLinkEdge = Edge2dComputed & {
  type: "inset-link"
}

export const linkInsetEdges = (a: InsetEdge, b: InsetEdge): InsetLinkEdge[] => {
  const { p0, p1, p2 } = adjacentInsetEdgesToPoints(a, b)

  const angle = findAngle(p0.original, p1.original)
  const angleBetweenEdges = findOffsetAngle(
    p1.original,
    p2.original,
    angle,
    undefined,
  )

  const setbacksAreSame = a.original.setback === b.original.setback
  const oneSetbackIsZero = a.original.setback === 0 || b.original.setback === 0
  const bothSetbacksAreZero = setbacksAreSame && oneSetbackIsZero

  if (a.originalId === `0-1` && b.originalId === `1-2`) {
    console.log({ angleBetweenEdges })
  }

  const isNearRightAngle = Math.abs(angleBetweenEdges - Math.PI / 2) < 0.0001

  const isNearStraight =
    angleBetweenEdges < 0.0001 ||
    Math.abs(angleBetweenEdges - Math.PI * 2) < 0.0001
  const angleBendsOutward = angleBetweenEdges - 0.0001 > Math.PI

  const useIntersectionBetweenOriginalEdges =
    bothSetbacksAreZero || (isNearStraight && setbacksAreSame)
  if (useIntersectionBetweenOriginalEdges) {
    return []
  }

  const extendThenLink = isNearRightAngle
  if (extendThenLink) {
    const slope1 = (p1.inset1.y - p0.inset0.y) / (p1.inset1.x - p0.inset0.x)
    const yIntercept1 = p1.inset1.y - slope1 * p1.inset1.x
    const extension1CoordinateX = p1.inset1.x + (p1.inset1.x - p0.inset0.x) * 0.1
    const extensionPoint1 = {
      x: extension1CoordinateX,
      y:
        slope1 < 1e7 && slope1 > -1e7
          ? slope1 * extension1CoordinateX + yIntercept1
          : p1.inset1.y + p1.inset1.y - p0.inset0.y,
    }

    const slope2 = (p1.inset2.y - p2.inset3.y) / (p1.inset2.x - p2.inset3.x)
    const yIntercept2 = p1.inset2.y - slope2 * p1.inset2.x
    const extensionPoint2 = {
      x: p1.inset2.x + (p1.inset2.x - p2.inset3.x) * 0.1,
      y:
        slope2 < 1e7 && slope2 > -1e7
          ? slope2 * (p1.inset2.x + (p1.inset2.x - p2.inset3.x) * 0.1) +
            yIntercept2
          : p1.inset2.y + p1.inset2.y - p2.inset3.y,
    }

    return [
      { p1: p1.inset1, p2: extensionPoint1, type: `inset-link` },
      { p1: extensionPoint1, p2: extensionPoint2, type: `inset-link` },
      { p1: extensionPoint2, p2: p1.inset2, type: `inset-link` },
    ]
  }

  const useInsetLinkEdge =
    angleBendsOutward || isNearStraight || oneSetbackIsZero
  if (useInsetLinkEdge) {
    return [{ p1: p1.inset1, p2: p1.inset2, type: `inset-link` }]
  }

  return [
    { p1: p1.inset1, p2: p1.original, type: `inset-link` },
    { p1: p1.original, p2: p1.inset2, type: `inset-link` },
  ]
}
